<template>
  <section class="apple-page apple-detail" :class="'apple-detail-' + kind" data-apple-detail>
    <component :is="detailComponent" :key="kind" ref="page" v-bind="$attrs" v-on="$listeners" />
  </section>
</template>
<script>
import AppleAlbum from './AppleAlbum.vue';
import AppleArtist from './AppleArtist.vue';
import ApplePlaylist from './ApplePlaylist.vue';
import './apple-pages.scss';
import './apple-secondary-pages.scss';
import './apple-detail-mobile.scss';
import './apple-detail-redesign.scss';
// Compact markup is reused without a different workspace or copied store.
const pages = {
  album: AppleAlbum,
  artist: AppleArtist,
  playlist: ApplePlaylist,
};
export default {
  name: 'AppleDetail', inheritAttrs: false,
  props: { kind: { type: String, required: true, validator: value => ['album', 'artist', 'playlist'].includes(value) } },
  data() { return { pageInstance: null }; },
  computed: {
    detailComponent() { return pages[this.kind]; },
    scrollRestoreState() { return this.pageInstance?.scrollRestoreState || { busy: true, more: true, failed: false }; },
  },
  mounted() { this.syncPage(); }, updated() { this.syncPage(); },
  methods: { syncPage() { if (this.pageInstance !== this.$refs.page) this.pageInstance = this.$refs.page || null; } },
};
</script>
